//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { testing, testingMessage, passcode } from '~/testing.config'
import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import AuthenticatePasscode from '~sdp-components/Authentication/AuthenticatePasscode'

export default {
  components: {
    Header,
    Navigation,
    Footer,
    AuthenticatePasscode,
  },
  data() {
    return {
      printMode: false,
      incorrectPasscodeMessage: undefined,
    }
  },
  head() {
    return {
      title: 'SPREE',
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated
    },
    bannerMessage() {
      return testing && testingMessage ? testingMessage : undefined
    },
  },

  methods: {
    setPrintMode(printMode) {
      if (printMode !== this.printMode) {
        this.printMode = printMode
        this.$router.push({ path: this.$route.path, query: { print: true } })
      }
    },
    async checkPasscode(_passcode) {
      const passcodeValid = _passcode === passcode
      await this.$store.dispatch('set_authenticated', passcodeValid)
      this.incorrectPasscodeMessage = passcodeValid
        ? undefined
        : 'Incorrect password, please try again.'
    },
  },
}
